import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { Link } from "react-router-dom"
import { connectNode } from '../../../../utils/global'

import '../../../../styles/assets/css/admin/list2.css'
import PatientHead3 from "../../patient/patient_head3"
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'

import FormPHQ4 from '../../../../pdf/PHQ-4.pdf'
import FormWHO5 from '../../../../pdf/WHO-5.pdf'
import FormPHQ9 from '../../../../pdf/PHQ-9.pdf'
import FormGAD7 from '../../../../pdf/GAD7.pdf'
import FormCOBRA from '../../../../pdf/COBRA.pdf'
import FormASRM from '../../../../pdf/ASRM.pdf'
import FormPW18 from '../../../../pdf/PW18.pdf'
import FormPSQI from '../../../../pdf/PSQI.pdf'
import FormDERS18 from '../../../../pdf/DERS-18.pdf'
import FormCSQ8 from '../../../../pdf/CSQ-8.pdf'
import FormCSI from '../../../../pdf/CSI.pdf'

import { phq4_choices, phq4_questions } from '../../../patients/variables/assessments/phq4.js'
import { who5_choices, who5_questions } from '../../../patients/variables/assessments/who5.js'
import { phq9_1, phq9_2, phq9_questions, phq9_question_10 } from '../../../patients/variables/assessments/phq9.js'
import { q1 as asrm_q1, q2 as asrm_q2, q3 as asrm_q3, q4 as asrm_q4, q5 as asrm_q5 } from '../../../patients/variables/assessments/asrm.js'
import { gad7_1, gad7_2, gad7_questions, gad7_question_8 } from '../../../patients/variables/assessments/gad7.js'
import { cobra_1, cobra_questions } from '../../../patients/variables/assessments/cobra.js'
import { pw18_questions, pw18_scale } from '../../../patients/variables/assessments/pw18.js'
import { ders18_questions, ders18_choices } from '../../../patients/variables/assessments/ders18.js'
import { q5_questions, q5_choices, q6_choices, q7_choices, q9_choices, q10_choices,
         q10_add_questions, q10_add_choices } from '../../../patients/variables/assessments/psqi.js'
import { covid_questions, q1, q2, q3, q4, q5, q6, q7, q8, q9, q10, q11 } from '../../../patients/variables/assessments/covid.js'
import { sccs_scale, sccs_questions } from '../../../patients/variables/assessments/sccs.js'
import { ismi_scale, ismi_questions } from '../../../patients/variables/assessments/ismi.js'
import { questions, answer_1, answer_2, answer_3, answer_4, answer_5, answer_6, answer_7, answer_8 } from '../../../patients/variables/assessments/csq8.js'
import { question1, question2, no_yes, type_provider, reason_service_q1,
         reason_service_q2  } from '../../../patients/variables/csi.js'
import { treatment_response, yes_no } from '../../../patients/variables/final_step.js'
import { tqe_q1_2, tqe_q3a, tqe_q3b, tqe_q4a, tqe_q4b, tqe_q5_6, answers_q1,
  answers_q2, answers_q3a, answers_q3b, answers_q4a, answers_q4b } from '../../../patients/variables/assessments/tqe.js'

class ViewAssessment extends Component {
  constructor() {
      super();
      this.state = {
        dataItems: {},
        time_type: '',
      }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var pid = this.props.match.params.pid
    var assm = this.props.match.params.assm
    var time_type = this.props.match.params.time_type
    var timepoint = this.props.match.params.timepoint
    if(this.props.time_type == 'r') {
      pid = this.props.pid
      assm = this.props.assm
      time_type = this.props.time_type
      timepoint = this.props.timepoint
    }
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/view_assessment',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: pid,
        assm: assm,
        time_type: time_type,
        timepoint: timepoint,
      }
    })
    .then((result) => {
      //console.log(result['data'])
        this.setState({
          dataItems: result['data'],
          time_type: time_type,
        })
      }
    )

  }

  findLabelByValue(arr, searchValue) {
    var label = ''
    var result = arr.find(obj => {
      return obj.value == searchValue
    })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  convert_date_time = (datetime) => {
    var getdate = datetime.substr(5, 2)+'/'+datetime.substr(8, 2)+'/'+datetime.substr(0, 4)
    getdate += ', '+datetime.substr(11, 8)
    return getdate
  }

  render() {
    console.log(this.props)
    return (
      <>
      {this.state.time_type != 'r' &&
      <div className="admin_patient_detail box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            {this.props.match.params.assm == 'phq4' && 'PHQ-4'}
            {this.props.match.params.assm == 'who5' && 'Well-Being Index (WHO-5)'}
            {this.props.match.params.assm == 'phq9' && 'The Patient Health Questionnaire (PHQ-9)'}
            {this.props.match.params.assm == 'asrm' && 'Altman Self-Rating Mania Scale (ASRM)'}
            {this.props.match.params.assm == 'gad7' && 'Generalized Anxiety Disorder Scale (GAD-7)'}
            {this.props.match.params.assm == 'cobra' && 'Cognitive Complaints in Bipolar Disorder Rating Assessment (COBRA)'}
            {this.props.match.params.assm == 'pw18' && 'Psychological Well-Being Scale (PWB)'}
            {this.props.match.params.assm == 'ders18' && 'Difficulties in Emotion Regulation Scale (DERS-18)'}
            {this.props.match.params.assm == 'psqi' && 'Pittsburgh Sleep Quality Index (PSQI)'}
            {this.props.match.params.assm == 'mtf' && 'Medication Tracking Form'}
            {this.props.match.params.assm == 'covid' && 'Coronavirus Impact Scale'}
            {this.props.match.params.assm == 'providers' && 'Providers'}
            {this.props.match.params.assm == 'csq8' && 'Client Satisfaction Questionnaire-8'}
            {this.props.match.params.assm == 'csi' && 'CSI - 24 Week Visit'}
            {this.props.match.params.assm == 'tqe' && 'Trackers and Questionnaires Experience '}
            {(this.props.match.params.assm == 'final_step' || this.props.assm == 'final_step') && 'Final Step'}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <PatientHead3 />
              <div className="row">
                <div className="small-12 columns box_inner2 top_space1">
                  <div className="small-12 columns">
                    <div className="small-11 columns title4">
                      {this.props.match.params.time_type == 'm' && this.props.match.params.timepoint == -1 && 'Baseline assessments'}
                      {this.props.match.params.time_type == 'm' && this.props.match.params.timepoint == -2 && 'Discharge assessments'}
                      {this.props.match.params.time_type == 'w' && 'Weekly assessments: '+this.props.match.params.timepoint }
                      {this.props.match.params.time_type == 'm' && this.props.match.params.timepoint != -1 && this.props.match.params.timepoint != -2 && 'Monthly assessments: '+this.props.match.params.timepoint }
                      {this.props.match.params.time_type == 'tm' && 'Trimonthly assessments: '+this.props.match.params.timepoint }
                      {this.props.match.params.time_type == 'sm' && 'Six-month assessments: '+this.props.match.params.timepoint }
                      {this.props.match.params.time_type == 'y' && 'Yearly assessments: '+this.props.match.params.timepoint }
                    </div>
                    <div className="small-1 columns">
                      {this.props.match.params.assm == 'phq9' &&
                        <Link to={FormPHQ9} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'asrm' &&
                        <Link to={FormASRM} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'gad7' &&
                        <Link to={FormGAD7} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'cobra' &&
                        <Link to={FormCOBRA} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'pw18' &&
                        <Link to={FormPW18} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'ders18' &&
                        <Link to={FormDERS18} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'csq8' &&
                        <Link to={FormCSQ8} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'psqi' &&
                        <Link to={FormPSQI} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'who5' &&
                        <Link to={FormWHO5} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'phq4' &&
                        <Link to={FormPHQ4} target="_blank"><PictureAsPdfIcon /></Link>}
                      {this.props.match.params.assm == 'csi' &&
                        <Link to={FormCSI} target="_blank"><PictureAsPdfIcon /></Link>}
                    </div>
                    {this.props.match.params.assm != 'mtf' &&
                    <div className="small-12 columns">
                      Start: {this.state.dataItems.start_datetime} | Finish: {this.state.dataItems.end_datetime && this.convert_date_time(this.state.dataItems.end_datetime)}
                    </div>}
                    <div className="small-12 columns sep_line2">&nbsp;</div>
                    {this.props.match.params.assm == 'phq4' &&
                    <div>{phq4_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(phq4_choices, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>}
                    {this.props.match.params.assm == 'who5' &&
                    <div>{who5_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(who5_choices, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>}
                    {this.props.match.params.assm == 'phq9' &&
                    <div>{phq9_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(phq9_1, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                        <div className="small-12 columns">
                          <div className="row">
                            <div className="small-9 columns">10. {this.findLabelByValue(phq9_question_10, 10)}</div>
                            <div className="small-3 columns">{this.findLabelByValue(phq9_2, this.state.dataItems['q10'])}</div>
                          </div>
                        </div>
                    </div>}
                    {this.props.match.params.assm == 'asrm' &&
                    <div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-3 columns txt2">Question 1:</div>
                          <div className="small-9 columns">{this.findLabelByValue(asrm_q1, this.state.dataItems['q1'])}</div>
                        </div>
                      </div>
                      <div className="small-12 columns sep_line1">&nbsp;</div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-3 columns txt2">Question 2:</div>
                          <div className="small-9 columns">{this.findLabelByValue(asrm_q2, this.state.dataItems['q2'])}</div>
                        </div>
                      </div>
                      <div className="small-12 columns sep_line1">&nbsp;</div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-3 columns txt2">Question 3:</div>
                          <div className="small-9 columns">{this.findLabelByValue(asrm_q3, this.state.dataItems['q3'])}</div>
                        </div>
                      </div>
                      <div className="small-12 columns sep_line1">&nbsp;</div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-3 columns txt2">Question 4:</div>
                          <div className="small-9 columns">{this.findLabelByValue(asrm_q4, this.state.dataItems['q4'])}</div>
                        </div>
                      </div>
                      <div className="small-12 columns sep_line1">&nbsp;</div>
                      <div className="small-12 columns">
                        <div className="row ">
                          <div className="small-3 columns txt2">Question 5:</div>
                          <div className="small-9 columns">{this.findLabelByValue(asrm_q5, this.state.dataItems['q5'])}</div>
                        </div>
                      </div>
                    </div>}
                    {this.props.match.params.assm == 'gad7' &&
                    <div>{gad7_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(gad7_1, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                        <div className="small-12 columns">
                          <div className="row">
                            <div className="small-9 columns">8. {this.findLabelByValue(gad7_question_8, 8)}</div>
                            <div className="small-3 columns">{this.findLabelByValue(gad7_2, this.state.dataItems['q8'])}</div>
                          </div>
                        </div>
                    </div>}
                    {this.props.match.params.assm == 'cobra' &&
                    <div>{cobra_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(cobra_1, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>}
                    {this.props.match.params.assm == 'pw18' &&
                    <div>{pw18_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(pw18_scale, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>}
                    {this.props.match.params.assm == 'ders18' &&
                    <div>{ders18_questions.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">{each.value}. {each.label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(ders18_choices, this.state.dataItems['q'+each.value])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>}
                    {this.props.match.params.assm == 'csq8' &&
                    <div>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">1. {questions[0].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_1, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">2. {questions[1].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_2, this.state.dataItems['q2'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">3. {questions[2].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_3, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">4. {questions[3].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_4, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">5. {questions[4].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_5, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">6. {questions[5].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_6, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">7. {questions[6].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_7, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-9 columns">8. {questions[7].label}</div>
                              <div className="small-3 columns">{this.findLabelByValue(answer_8, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">Comments:<br />
                              {this.state.dataItems['comments']}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>}
                    {this.props.match.params.assm == 'tqe' &&
                    <div>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-6 columns">1. {tqe_q1_2[0].label}</div>
                              <div className="small-6 columns">{this.findLabelByValue(answers_q1, this.state.dataItems['q1'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-6 columns">2. {tqe_q1_2[1].label}</div>
                              <div className="small-6 columns">{this.findLabelByValue(answers_q2, this.state.dataItems['q2'])}</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">3a. {tqe_q3a[0].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                {[
                                  this.state.dataItems.q3a1 > 0 && answers_q3a[0].label,
                                  this.state.dataItems.q3a2 > 0 && answers_q3a[1].label,
                                  this.state.dataItems.q3a3 > 0 && answers_q3a[2].label,
                                  this.state.dataItems.q3a4 > 0 && answers_q3a[3].label,
                                  this.state.dataItems.q3a5 > 0 &&
                                    answers_q3a[4].label +
                                      (this.state.dataItems.q3a5_other?.length
                                        ? `: ${this.state.dataItems.q3a5_other}` : '')
                                ]
                                  .filter(Boolean)
                                  .map((text, idx) => (
                                    <li key={idx}>{text}</li>
                                  ))}
                              </ul>
                              </div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">3b. {tqe_q3b[0].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                {[
                                  this.state.dataItems.q3b1 > 0 && answers_q3b[0].label,
                                  this.state.dataItems.q3b2 > 0 && answers_q3b[1].label,
                                  this.state.dataItems.q3b3 > 0 && answers_q3b[2].label,
                                  this.state.dataItems.q3b4 > 0 && answers_q3b[3].label,
                                  this.state.dataItems.q3b5 > 0 &&
                                    answers_q3b[4].label +
                                      (this.state.dataItems.q3b5_other?.length
                                        ? `: ${this.state.dataItems.q3b5_other}` : '')
                                ]
                                  .filter(Boolean)
                                  .map((text, idx) => (
                                    <li key={idx}>{text}</li>
                                  ))}
                              </ul>
                              </div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">4a. {tqe_q4a[0].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                {[
                                  this.state.dataItems.q4a1 > 0 && answers_q4a[0].label,
                                  this.state.dataItems.q4a2 > 0 && answers_q4a[1].label,
                                  this.state.dataItems.q4a3 > 0 && answers_q4a[2].label,
                                  this.state.dataItems.q4a4 > 0 && answers_q4a[3].label,
                                  this.state.dataItems.q4a5 > 0 && answers_q4a[4].label,
                                  this.state.dataItems.q4a6 > 0 &&
                                    answers_q4a[5].label +
                                      (this.state.dataItems.q4a6_other?.length
                                        ? `: ${this.state.dataItems.q4a6_other}` : '')
                                ]
                                  .filter(Boolean)
                                  .map((text, idx) => (
                                    <li key={idx}>{text}</li>
                                  ))}
                              </ul>
                              </div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">4b. {tqe_q4b[0].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                {[
                                  this.state.dataItems.q4b1 > 0 && answers_q4b[0].label,
                                  this.state.dataItems.q4b2 > 0 && answers_q4b[1].label,
                                  this.state.dataItems.q4b3 > 0 && answers_q4b[2].label,
                                  this.state.dataItems.q4b4 > 0 && answers_q4b[3].label,
                                  this.state.dataItems.q4b5 > 0 && answers_q4b[4].label,
                                  this.state.dataItems.q4b6 > 0 &&
                                    answers_q4b[5].label +
                                      (this.state.dataItems.q4b6_other?.length
                                        ? `: ${this.state.dataItems.q4b6_other}` : '')
                                ]
                                  .filter(Boolean)
                                  .map((text, idx) => (
                                    <li key={idx}>{text}</li>
                                  ))}
                              </ul>
                              </div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">5. {tqe_q5_6[0].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}><li>{this.state.dataItems['q5']}</li></ul></div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns">6. {tqe_q5_6[1].label}</div>
                              <div className="small-12 columns">
                              <ul style={{ margin: 0, paddingLeft: '20px' }}><li>{this.state.dataItems['q6']}</li></ul></div>
                            </div>
                          </div>
                        </div>
                    </div>}
                    {this.props.match.params.assm == 'csi' &&
                    <div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-12 columns bold">Which of the following Psychological Services have you used in the past 3 months?</div>
                            <div className="small-12 columns bold">Have you sought help for emotional problems from anyone else in the past 3 months?</div>
                          </div>
                        </div>
                        <div className="small-12 columns sep_line2">&nbsp;</div>
                        {question1.map(each => <>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-9 columns">{each.value}. {each.label}</div>
                            <div className="small-3 columns">{this.findLabelByValue(no_yes, this.state.dataItems['q'+each.value])}</div>
                          </div>
                        </div>
                        {this.state.dataItems['q'+each.value] == 1 && <>
                        <div className="small-12 columns sep_line3">&nbsp;</div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-3 columns align_right">Type of provider:</div>
                            <div className="small-9 columns">
                            {this.findLabelByValue(type_provider, this.state.dataItems['q'+each.value+'_provider'])}
                            {this.state.dataItems['q'+each.value+'_provider'] == 9 && ' ['+this.state.dataItems['q'+each.value+'_provider_other']+']' }
                            </div>
                          </div>
                        </div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-3 columns align_right">Reason for service:</div>
                            <div className="small-9 columns">
                            {this.findLabelByValue(reason_service_q1, this.state.dataItems['q'+each.value+'_reason'])}
                            {this.state.dataItems['q'+each.value+'_reason'] == 5 && ' ['+this.state.dataItems['q'+each.value+'_reason_other']+']'}
                            </div>
                          </div>
                        </div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-3 columns align_right">Frequency of service:</div>
                            <div className="small-9 columns">
                            {this.state.dataItems['q'+each.value+'_frequency']} &nbsp;
                            (record number of times during the past 90 days service was used)
                            </div>
                          </div>
                        </div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-3 columns align_right">Number of minutes/visit:</div>
                            <div className="small-9 columns">
                            {this.state.dataItems['q'+each.value+'_mins']}
                            </div>
                          </div>
                        </div>
                        </>}
                        <div className="small-12 columns sep_line1">&nbsp;</div></>)}
                        <div className="small-12 columns sep_line2">&nbsp;</div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-12 columns bold">Have you used any of the following services in the past 3 months?</div>
                          </div>
                        </div>
                        <div className="small-12 columns sep_line2">&nbsp;</div>
                        {question2.map(each => <>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-9 columns">{each.value}. {each.label}</div>
                            <div className="small-3 columns">{this.findLabelByValue(no_yes, this.state.dataItems['q'+each.value])}</div>
                          </div>
                        </div>
                        {this.state.dataItems['q'+each.value] == 1 && <>
                        <div className="small-12 columns sep_line3">&nbsp;</div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-4 columns align_right">Duration/frequency of service:</div>
                            <div className="small-8 columns">
                            {this.state.dataItems['q'+each.value+'_duration']}
                            </div>
                          </div>
                        </div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-4 columns align_right">Reason for service:</div>
                            <div className="small-8 columns">
                            {this.findLabelByValue(reason_service_q2, this.state.dataItems['q'+each.value+'_reason'])}
                            {this.state.dataItems['q'+each.value+'_reason'] == 6 && ' ['+this.state.dataItems['q'+each.value+'_reason_other']+']'}
                            </div>
                          </div>
                        </div>
                        </>}
                        <div className="small-12 columns sep_line1">&nbsp;</div></>)}
                      </div>
                    </div>}
                    {(this.props.match.params.assm == 'final_step') &&
                    <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-9 columns">In the past three months, how would you describe your response to your bipolar treatment?</div>
                            <div className="small-3 columns">{this.findLabelByValue(treatment_response, this.state.dataItems['treatment_response'])}</div>
                          </div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-9 columns">Have you experienced a major life event in the last three months?
                            Examples of a major life event include loss or death of spouse,
                            partner, child, or other close family member; major health problem(s);
                            loss of job/serious money problems; moving to a new apartment/house/group
                            home, etc.; physical or emotional abuse; serious disaster or accident.</div>
                            <div className="small-3 columns">{this.findLabelByValue(yes_no, this.state.dataItems['major_life_event'])}</div>
                          </div>
                        </div>
                        {this.state.dataItems['major_life_event'] == 1 && <>
                        <div className="small-12 columns top_space1">
                          <div className="row no_margin_bottom">
                            <div className="small-12 columns">How many: {this.state.dataItems['major_life_event_score']}</div>
                          </div>
                        </div>
                        <div className="small-12 columns top_space1">
                          <div className="row no_margin_bottom">
                            <div className="small-12 columns">Please specify: {this.state.dataItems['major_life_event_specify']}</div>
                          </div>
                        </div>
                        </>}
                      </div>}
                    {this.props.match.params.assm == 'psqi' &&
                    <div>
                      <div className="row">
                        <div className="small-12 columns box1">
                          <div className="row no_margin_bottom">

                            <div className="small-12 medium-10 columns bold">
                                1. During the past month, when have you usually gone to bed at night?
                            </div>
                            <div className="small-12 medium-2 columns ">
                              {this.state.dataItems['q1']}
                            </div>
                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>

                            <div className="small-12 medium-10 columns bold">
                                2. During the past month, how long (in minutes) has it usually take you to fall asleep each night?
                            </div>
                            <div className="small-12 medium-2 columns">
                              {this.state.dataItems['q2']}
                            </div>
                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>

                            <div className="small-12 medium-10 columns bold">
                                3. During the past month, when have you usually gotten up in the morning?
                            </div>
                            <div className="small-12 medium-2 columns">
                              {this.state.dataItems['q3']}
                            </div>
                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>

                            <div className="small-12 medium-10 columns bold">
                                4. During the past month, how many hours of actual sleep did you get a night? (This may be different than the number of hours you spend in bed.)
                            </div>
                            <div className="small-12 medium-2 columns">
                              {this.state.dataItems['q4']}
                            </div>
                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                            <div className="small-12 columns bold">
                                5. During the past month, how often have you had trouble sleeping because you...
                            </div>
                            <div className="small-12 columns">
                            {this.findLabelByValue(q5_choices, this.state.dataItems['q5'])}
                            {q5_questions.map(eachQ =>
                              <div className="top_space1" key={"q5"+eachQ.value} >
                                <div className="small-12 medium-8 columns">
                                  {eachQ.label}
                                  {eachQ.value==10 && this.state.dataItems['q510_other']}
                                </div>
                                <div className="small-12 medium-4 columns">
                                  {this.findLabelByValue(q5_choices, this.state.dataItems['q5'+eachQ.value])}
                                </div>
                              </div>)}
                            </div>
                            <div className="small-12 columns top_space2">
                              <div className="row">
                                <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                                <div className="small-12 medium-9 columns bold">
                                  6. During the past month, how would you rate your sleep quality overall?
                                </div>
                                <div className="small-12 medium-3 columns">
                                  {this.findLabelByValue(q6_choices, this.state.dataItems['q6'])}
                                </div>
                                <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                                <div className="small-12 medium-9 columns bold">
                                  7. During the past month, how often have you taken medicine
                                  (prescribed or "over the counter") to help you sleep?
                                </div>
                                <div className="small-12 medium-3 columns">
                                  {this.findLabelByValue(q7_choices, this.state.dataItems['q7'])}
                                </div>
                                <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                                <div className="small-12 medium-9 columns bold">
                                  8. During the past month, how often have you had trouble staying
                                  awake while driving, eating meals, or engaging in social activity?
                                </div>
                                <div className="small-12 medium-3 columns">
                                  {this.findLabelByValue(q7_choices, this.state.dataItems['q8'])}
                                </div>
                              </div>
                            </div>

                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                            <div className="small-12 medium-9 columns bold">
                              9. During the past month, how much of a problem has it been for you
                              to keep up enough enthusiasm to get things done?
                            </div>
                            <div className="small-12 medium-3 columns">
                              {this.findLabelByValue(q9_choices, this.state.dataItems['q9'])}
                            </div>

                            <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                            <div className="small-12 medium-9 columns bold">
                              10. Do you have a bed partner or room mate?
                            </div>
                            <div className="small-12 medium-3 columns">
                              {this.findLabelByValue(q10_choices, this.state.dataItems['q10'])}
                            </div>

                            { this.state.dataItems['q10'] >2 &&
                            <div>
                              <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                              <div className="small-12 columns bold">
                                <ArrowRightIcon />  If you have a roommate or bed partner, ask him/her how often in the past month you have had...
                              </div>
                              <div className="small-12 columns"><div className="sep_line1">&nbsp;</div></div>
                              <div className="small-12 columns top_space2">
                                <div className="row">
                                  {q10_add_questions.map(eachQ =>
                                    <div className="">
                                      <div className="small-12 medium-9 columns">
                                        {eachQ.label}
                                        {eachQ.value==5 && this.state.dataItems['q105_other']}
                                      </div>
                                      <div className="small-12 medium-3 columns">
                                        {this.findLabelByValue(q10_add_choices, this.state.dataItems['q10'+eachQ.value])}
                                      </div>
                                      {eachQ.value < 5 &&
                                      <div className="small-12 columns">
                                        <div className="sep_line1">&nbsp;</div>
                                      </div>}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>}

                          </div>
                        </div>
                      </div>
                    </div>}
                    {this.props.match.params.assm == 'mtf' && this.state.dataItems.length>0 &&
                    <div>
                    <div>{this.state.dataItems.map(each =>
                        <div>
                          <div className="small-12 columns">
                            <div className="row no_margin_bottom">
                              <div className="small-12 columns"><span className="bold">Medication name: </span>{each.med_other}</div>
                              <div className="small-12 columns"><span className="bold">Dosage: </span>{each.y_dose} mg</div>
                            </div>
                          </div>
                          <div className="small-12 columns sep_line1">&nbsp;</div>
                        </div>)}
                    </div>
                  </div>}
                  {this.props.match.params.assm == 'mtf' && this.state.dataItems==0 &&
                  <div className="small-12 columns">
                    No medication submitted
                  </div>}
                  {this.props.match.params.assm == 'covid' &&
                  <div>{covid_questions.map(each =>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom">
                            <div className="small-6 columns">{each.value}. {each.label}</div>
                            <div className="small-6 columns">
                            { each.value == 1 && this.findLabelByValue(q1, this.state.dataItems['q'+each.value]) }
                            { each.value == 2 && this.findLabelByValue(q2, this.state.dataItems['q'+each.value]) }
                            { each.value == 3 && this.findLabelByValue(q3, this.state.dataItems['q'+each.value]) }
                            { each.value == 4 && this.findLabelByValue(q4, this.state.dataItems['q'+each.value]) }
                            { each.value == 5 && this.findLabelByValue(q5, this.state.dataItems['q'+each.value]) }
                            { each.value == 6 && this.findLabelByValue(q6, this.state.dataItems['q'+each.value]) }
                            { each.value == 7 && this.findLabelByValue(q7, this.state.dataItems['q'+each.value]) }
                            { each.value == 8 && this.findLabelByValue(q8, this.state.dataItems['q'+each.value]) }
                            { each.value == 9 && this.findLabelByValue(q9, this.state.dataItems['q'+each.value]) }
                            { each.value == 10 && this.findLabelByValue(q10, this.state.dataItems['q10_num']) }
                            { each.value == 11 && this.findLabelByValue(q11, this.state.dataItems['q11_num']) }
                            { each.value == 12 && this.state.dataItems['q'+each.value] }
                            </div>
                          </div>
                        </div>
                        {each.value == 10 &&  this.state.dataItems['q10_num']>0 &&
                        <div className="small-12 columns">
                          <ArrowRightIcon /> Rate the symptoms of the person who was most sick:
                          {this.findLabelByValue(q10, this.state.dataItems['q10'])}
                        </div>}
                        {each.value == 11 && this.state.dataItems['q11_num']>0 &&
                        <div className="small-12 columns">
                          <ArrowRightIcon /> Rate the symptoms of the person who was most sick:
                          {this.findLabelByValue(q11, this.state.dataItems['q11'])}
                        </div>}
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>)}
                  </div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {(this.state.time_type == 'r' && this.props.assm == 'csi') && <>
      <div className="small-12 columns">
        <div className="w50m_w100s title1">CSI</div>
        <div className="w50m_w100s title1 right_date">Submitted: {this.state.dataItems.end_datetime && this.convert_date_time(this.state.dataItems.end_datetime)}</div>
      </div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-12 columns bold">Which of the following Psychological Services have you used in the past 3 months?</div>
          <div className="small-12 columns bold">Have you sought help for emotional problems from anyone else in the past 3 months?</div>
        </div>
      </div>
      <div className="small-12 columns sep_line2">&nbsp;</div>
      {question1.map(each => <>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-9 columns">{each.value}. {each.label}</div>
          <div className="small-3 columns">{this.findLabelByValue(no_yes, this.state.dataItems['q'+each.value])}</div>
        </div>
      </div>
      {this.state.dataItems['q'+each.value] == 1 && <>
      <div className="small-12 columns sep_line3">&nbsp;</div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-3 columns align_right">Type of provider:</div>
          <div className="small-9 columns">
          {this.findLabelByValue(type_provider, this.state.dataItems['q'+each.value+'_provider'])}
          {this.state.dataItems['q'+each.value+'_provider'] == 9 && ' ['+this.state.dataItems['q'+each.value+'_provider_other']+']' }
          </div>
        </div>
      </div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-3 columns align_right">Reason for service:</div>
          <div className="small-9 columns">
          {this.findLabelByValue(reason_service_q1, this.state.dataItems['q'+each.value+'_reason'])}
          {this.state.dataItems['q'+each.value+'_reason'] == 5 && ' ['+this.state.dataItems['q'+each.value+'_reason_other']+']'}
          </div>
        </div>
      </div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-3 columns align_right">Frequency of service:</div>
          <div className="small-9 columns">
          {this.state.dataItems['q'+each.value+'_frequency']} &nbsp;
          (record number of times during the past 90 days service was used)
          </div>
        </div>
      </div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-3 columns align_right">Number of minutes/visit:</div>
          <div className="small-9 columns">
          {this.state.dataItems['q'+each.value+'_mins']}
          </div>
        </div>
      </div>
      </>}
      <div className="small-12 columns sep_line1">&nbsp;</div></>)}
      <div className="small-12 columns sep_line2">&nbsp;</div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-12 columns bold">Have you used any of the following services in the past 3 months?</div>
        </div>
      </div>
      <div className="small-12 columns sep_line2">&nbsp;</div>
      {question2.map(each => <>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-9 columns">{each.value}. {each.label}</div>
          <div className="small-3 columns">{this.findLabelByValue(no_yes, this.state.dataItems['q'+each.value])}</div>
        </div>
      </div>
      {this.state.dataItems['q'+each.value] == 1 && <>
      <div className="small-12 columns sep_line3">&nbsp;</div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-4 columns align_right">Duration/frequency of service:</div>
          <div className="small-8 columns">
          {this.state.dataItems['q'+each.value+'_duration']}
          </div>
        </div>
      </div>
      <div className="small-12 columns">
        <div className="row no_margin_bottom">
          <div className="small-4 columns align_right">Reason for service:</div>
          <div className="small-8 columns">
          {this.findLabelByValue(reason_service_q2, this.state.dataItems['q'+each.value+'_reason'])}
          {this.state.dataItems['q'+each.value+'_reason'] == 6 && ' ['+this.state.dataItems['q'+each.value+'_reason_other']+']'}
          </div>
        </div>
      </div>
      </>}
      <div className="small-12 columns sep_line1">&nbsp;</div></>)}
      </>}
      {(this.state.time_type == 'r' && this.props.assm == 'final_step') &&
      <div>
        <div className="small-12 columns">
          <div className="w50m_w100s title1">Treatment Response</div>
          <div className="w50m_w100s title1 right_date">Submitted: {this.state.dataItems.end_datetime && this.convert_date_time(this.state.dataItems.end_datetime)}</div>
        </div>
        <div className="small-12 columns">
          <div className="row no_margin_bottom">
            <div className="small-9 columns">In the past three months, how would you describe your response to your bipolar treatment?</div>
            <div className="small-3 columns">{this.findLabelByValue(treatment_response, this.state.dataItems['treatment_response'])}</div>
          </div>
        </div>

        <div className="small-12 columns top_space1">
          <div className="w50m_w100s title1">Major Life Events</div>
          <div className="w50m_w100s title1 right_date">&nbsp;</div>
        </div>
        <div className="small-12 columns">
          <div className="row no_margin_bottom">
            <div className="small-9 columns">Have you experienced one or more major life events in the last three months?
            Examples of a major life event include loss or death of spouse,
            partner, child, or other close family member; major health problem(s);
            loss of job/serious money problems; moving to a new apartment/house/group
            home, etc.; physical or emotional abuse; serious disaster or accident.</div>
            <div className="small-3 columns">{this.findLabelByValue(yes_no, this.state.dataItems['major_life_event'])}</div>
          </div>
        </div>
        {this.state.dataItems['major_life_event'] == 1 && <>
        <div className="small-12 columns top_space1">
          <div className="row no_margin_bottom">
            <div className="small-12 columns">How many: {this.state.dataItems['major_life_event_score']}</div>
          </div>
        </div>
        <div className="small-12 columns top_space1">
          <div className="row no_margin_bottom">
            <div className="small-12 columns">Please specify: {this.state.dataItems['major_life_event_specify']}</div>
          </div>
        </div>
        </>}
      </div>}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ViewAssessment)
